import { createContext } from 'react';

import type { FilterFacetsContextValue } from './filterFacetsContextTypes';

export const FilterFacetsContext =
  createContext<FilterFacetsContextValue | null>(null);
